const pl = {
  translation: {
    nav: {
      home: "Strona główna",
      categories: "Kategorie",
      blog: "Poradnik",
      shoppingGuide: "Poradnik Zakupowy",
      kakobuySpreadsheet: "Kakobuy Spreadsheet",
      buyItNow: "Buy It Now",
    },
    hero: {
      h1: "Kakobuy Spreadsheet Polska – Największa Baza Produktów i Findów z Chin",
      subtitle: "Znajdź najlepsze produkty z Kakobuy Spreadsheet. Przeglądaj sprawdzone linki, popularne kategorie, porównania cen oraz poradniki dla początkujących użytkowników.",
      primaryCta: "Otwórz Kakobuy Spreadsheet",
      secondaryCta: "Jak działa Kakobuy?",
      badge1: "Aktualizowane listy produktów",
      badge2: "Kategorie premium",
      badge3: "Poradnik dla początkujących",
      badge4: "Bezpieczne zakupy",
    },
    why: {
      title: "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
    },
    categories: {
      title: "Najpopularniejsze kategorie Kakobuy Spreadsheet",
      dropdownPlaceholder: "Wybierz kategorię...",
    },
    comparison: {
      title: "Kakobuy Spreadsheet vs Standardowe zakupy",
      colSpreadsheet: "Kakobuy Spreadsheet",
      colStandard: "Standardowe wyszukiwanie",
    },
    howItWorks: {
      title: "Jak działa Kakobuy Spreadsheet?",
    },
    blog: {
      title: "Najnowszy poradnik Kakobuy",
      readMore: "Czytaj więcej",
    },
    cta: {
      headline: "Gotowy znaleźć najlepsze Kakobuy Finds?",
      subtext: "Dołącz do tysięcy zadowolonych kupujących i odkryj świat produktów z Chin dzięki Kakobuy Spreadsheet.",
      button: "Przejdź do Kakobuy Spreadsheet",
    },
    footer: {
      copyright: "© 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.",
      disclaimer: "Ta strona jest niezależnym przewodnikiem i nie jest powiązana z Kakobuy. Wszystkie znaki towarowe należą do ich właścicieli.",
      homeLink: "Strona główna",
      articleLink: "Poradnik Kakobuy",
    },
    article: {
      backToHome: "← Powrót do strony głównej",
      breadcrumbHome: "Strona główna",
      breadcrumbArticle: "Poradnik",
    },
  },
};

export default pl;